import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-idle-warning-modal',
    templateUrl: './idle-warning-modal.component.html',
    styleUrl: './idle-warning-modal.component.scss',
    standalone: false
})
export class IdleWarningModalComponent {
  
  @Input() countdownSeconds: number = 0;
  @Output() logoutClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() continueWorkingClicked: EventEmitter<void> = new EventEmitter<void>();
  
  idleMessage: string = `For security, you will be logged out after ${Math.ceil(this.countdownSeconds/60)} minutes of inactivity. Click "Continue Working" to keep your session open.`;

  onCountdownChanged(seconds: number): void {
    this.countdownSeconds = seconds;

    this.idleMessage = `For security, you will be logged out after ${Math.ceil(seconds/60)} minutes of inactivity. Click "Continue Working" to keep your session open.`;

  }

  onBtnContinueWorkingClick(): void {
    this.continueWorkingClicked.emit();
  }

  onBtnLogoutClick(): void {
    this.logoutClicked.emit();
  }
}
